import React, { FunctionComponent } from 'react';
import { Fade, Grid, Typography } from '@mui/material';
import moment from 'moment';

import { IPenaltyWaiver } from '../../../../../../../../../store/V2/PenaltyWaiverSlice';
import { ISection } from '../../../../../../../../../store/V2/SectionSlice';
import { getFormatedDurationByMinutes } from '../../../../../../../../../helper';
import { ICourse } from '../../../../../../../../../store/V2/CoursesSlice';

interface ClassDetailsTabProps {
  penaltyWaiver: IPenaltyWaiver;
}

const DetailItem = (props: { title: string; description: string }) => {
  const { title, description } = props;

  return (
    <Grid container columnSpacing="16px">
      <Grid item xs={6}>
        <div>
          <Typography fontSize="14px" fontWeight={500} color="#94A3B8">
            {title}
          </Typography>
        </div>
      </Grid>
      <Grid item xs={6}>
        <div>
          <Typography fontSize="14px" fontWeight={500} color="#1E293B">
            {description}
          </Typography>
        </div>
      </Grid>
    </Grid>
  );
};

const ClassDetailsTab: FunctionComponent<ClassDetailsTabProps> = ({
  penaltyWaiver,
}) => {
  const sectionData = penaltyWaiver.section as ISection;
  const courseData = penaltyWaiver.course as ICourse;
  const subject = courseData && courseData.subject ? courseData.subject : '';
  const grade = courseData && courseData.grade ? courseData.grade : '';
  const curriculum =
    courseData && courseData.curriculum ? courseData.curriculum : '';

  const startMoment = sectionData.dateTime
    ? moment(sectionData.dateTime)
    : undefined;

  const endMoment =
    sectionData.dateTime && sectionData.duration
      ? moment(sectionData.dateTime).add(sectionData.duration, 'minutes')
      : undefined;

  const formatedDuration = sectionData.duration
    ? getFormatedDurationByMinutes({ minutes: sectionData.duration })
    : '';

  return (
    <Fade in>
      <div>
        <div style={{ marginBottom: '16px' }}>
          <Typography fontWeight={600} fontSize="16px">
            Class Information
          </Typography>
        </div>
        <div>
          <Grid container rowSpacing="12px" columnSpacing="32px">
            <Grid item xs={12} sm={6}>
              <DetailItem
                title="Class Date"
                description={
                  startMoment ? startMoment.format('ddd MMM DD YYYY') : '-'
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DetailItem
                title="Class start time"
                description={startMoment ? startMoment.format('hh:mm A') : '-'}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DetailItem
                title="Class end time"
                description={endMoment ? endMoment.format('hh:mm A') : '-'}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DetailItem
                title="Class duration"
                description={formatedDuration || '-'}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DetailItem title="Subject" description={subject || '-'} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DetailItem title="Curriculum" description={curriculum || '-'} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DetailItem title="Grade" description={grade || '-'} />
            </Grid>
          </Grid>
        </div>
      </div>
    </Fade>
  );
};

export default ClassDetailsTab;
